import { SubscriptionProductNamesEnum } from "dash-common";

/**
 * Subscription theme configuration
 * Centralized color definitions for subscription UI components
 */
export const SUBSCRIPTION_THEMES = {
  basic: {
    bg: "#C0DEEE",
    title: "#383838",
    text: "#383838",
    price: "#383838",
    buttonBg: "#FFFFFF",
    buttonBgHover: "#f0fafd",
    buttonText: "#383838",
    accent: "#383838",
  },
  premium: {
    // Pro, Exchange, etc.
    bg: "#337ab7",
    title: "#FFFFFF",
    text: "#FFFFFF",
    price: "#FFFFFF",
    buttonBg: "#FFFFFF",
    buttonBgHover: "#f0fafd",
    buttonText: "#337ab7",
    accent: "#FFFFFF",
  },
} as const;

/**
 * Shared colors used across subscription components
 */
export const SUBSCRIPTION_COLORS = {
  primary: "#337ab7", // Primary blue for toggles, icons, etc.
  featureIcon: "#337ab7", // Blue for feature checkmarks (matches premium card bg)
  featureText: "#575A6D", // Gray for feature descriptions
  secondaryText: "#575A6D", // Gray for secondary text
  skeletonBg: "#e0e0e0", // Light gray for skeleton loading states
  white: "#ffffff", // White for backgrounds
} as const;

/**
 * Feature flags for subscription components
 */
export const ENABLE_YEARLY_PLANS = true; // Set to false to fallback to six-month plans

/**
 * Subscription pricing configuration
 */
export const SUBSCRIPTION_CONFIG = {
  yearly: {
    discount: 10, // 10% discount for yearly plans
    billingPeriodKey: "pages:subscriptionPlans.billedAnnually",
  },
  sixMonth: {
    discount: 10, // 10% discount for six-month plans
    billingPeriodKey: "pages:subscriptionPlans.billedEverySixMonths",
  },
} as const;

/**
 * External URLs for subscription-related actions
 */
export const DEMO_BOOKING_URL = "https://dashtodash.com/book-a-demo/";

/**
 * Get the appropriate theme for a subscription product
 */
export function getSubscriptionTheme(productName: string) {
  const isBasic = [
    SubscriptionProductNamesEnum.BASIC,
    SubscriptionProductNamesEnum.DIRECT,
  ].includes(productName as any);

  return isBasic ? SUBSCRIPTION_THEMES.basic : SUBSCRIPTION_THEMES.premium;
}
